import React, { memo } from 'react';
import { DisabledSavePasswordInputStyled } from './styles';

const DisabledSavePasswordInput = () => (
  <DisabledSavePasswordInputStyled autoComplete="false" name="hidden" type="text" />
);

export default memo(DisabledSavePasswordInput);
